// extracted by mini-css-extract-plugin
export var bordered = "SectionHeader-module--bordered--4e326";
export var centered = "SectionHeader-module--centered--9c404";
export var constrained = "SectionHeader-module--constrained--d6b33";
export var cta = "SectionHeader-module--cta--4f07e";
export var header = "SectionHeader-module--header--64089";
export var hero = "SectionHeader-module--hero--b561a";
export var inverted = "SectionHeader-module--inverted--973a4";
export var label = "SectionHeader-module--label--4761b";
export var labelDecorated = "SectionHeader-module--labelDecorated--5d3cf";
export var margin = "SectionHeader-module--margin--284f7";
export var marginExtraLight = "SectionHeader-module--marginExtraLight--bd5d2";
export var marginLight = "SectionHeader-module--marginLight--e1c4f";
export var marginTop = "SectionHeader-module--marginTop--9fa03";
export var narrow = "SectionHeader-module--narrow--56757";
export var post = "SectionHeader-module--post--20c29";
export var subtitle = "SectionHeader-module--subtitle--0a9ee";
export var subtitleContrasted = "SectionHeader-module--subtitleContrasted--83b6e";
export var subtitleHuge = "SectionHeader-module--subtitleHuge--70424";